import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = { class: "flex flex-col" }
const _hoisted_2 = { key: 0 }
const _hoisted_3 = ["innerHTML"]

import { ref } from "vue";
import { DbInput } from "@db-ui/v-elements-enterprise/dist/components";

export default /*@__PURE__*/_defineComponent({
  __name: 'DbInput',
  props: {
  type: {
    type: String,
    default: "text",
    required: false,
  },
  modelValue: {
    default: "",
  },
  placeholder: {
    default: "",
  },
  disabled: {
    default: false,
  },
  errorMessage: {
    type: String,
    default: undefined,
    required: false,
  },
  name: {
    default: "",
    required: false,
  },
  label: {
    default: "",
    required: false,
  },
  ariainvalid: {
    type: String as () =>
      | "false"
      | "grammar"
      | "spelling"
      | "true"
      | undefined
      | "",
    default: "false",
    required: false,
  },
},
  setup(__props) {

const input = ref("");


return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_unref(DbInput), {
      type: __props.type,
      label: __props.label,
      name: __props.name,
      disabled: __props.disabled,
      placeholder: __props.placeholder,
      value: __props.modelValue,
      variant: "semitransparent",
      onInput: _cache[0] || (_cache[0] = ($event: any) => (_ctx.$emit('update:modelValue', $event.target.value))),
      ref_key: "input",
      ref: input,
      ariainvalid: __props.ariainvalid
    }, null, 8, ["type", "label", "name", "disabled", "placeholder", "value", "ariainvalid"]),
    (__props.errorMessage)
      ? (_openBlock(), _createElementBlock("span", _hoisted_2, [
          _createElementVNode("p", {
            class: "showError",
            innerHTML: __props.errorMessage
          }, null, 8, _hoisted_3)
        ]))
      : _createCommentVNode("", true)
  ]))
}
}

})